import { populateMissingMarkerProps } from './populate-missing-marker-props.js';
import { populateMissingTrackProps } from './populate-missing-track-props.js';
import type { AnnotationsTrackConfigProperties } from '../types/annotations-config-properties.js';
import type { AnnotationsTrackConfig } from '../types/annotations-track-props.js';

/**
 * Applies the same defaulting (`color`, `priority`, `hidden`, `id`) that slot-provided tracks/markers
 * get from `populateMissingTrackProps`/`populateMissingMarkerProps` to tracks coming from a
 * `HistogramChartConfig`/`TimeseriesChartConfig` context config. Without this, config-provided
 * annotations reach the renderer with missing required fields and crash.
 */
export function populateMissingContextTracksProps(
  tracks: AnnotationsTrackConfigProperties[],
): AnnotationsTrackConfig[] {
  return tracks.map((track) => {
    const { markers, ...trackProps } = track;

    return populateMissingTrackProps({
      ...trackProps,
      markers: markers.map((marker) =>
        populateMissingMarkerProps(marker, trackProps),
      ),
    });
  });
}
